import * as z from 'zod';

// Types
import { blocksSchemaZod } from '@/components/blocks/Blocks';
import { SeoZod } from '@/types/SeoType';

const HomeZod = z.object({
  id: z.number(),
  documentId: z.string(),
  blocks: z.array(blocksSchemaZod),
  seo: SeoZod,
});

export { HomeZod };
export type HomeType = z.infer<typeof HomeZod>;
